import type { PropsWithChildren } from 'react';

import { useWebView } from '@myrealtrip/device-detect';
import dynamic from 'next/dynamic';

const GNBHeader = dynamic(() => import('./gnb/GNBHeader'), { ssr: false });
const GNBFooter = dynamic(() => import('./gnb/GNBFooter'), { ssr: false });

interface Props {
  hideHeader?: boolean;
  hideFooter?: boolean;
}

export default function CommonLayout({
  hideHeader = false,
  hideFooter = false,
  children,
}: PropsWithChildren<Props>) {
  const { isWebView } = useWebView();

  if (isWebView) {
    return <>{children}</>;
  }

  return (
    <>
      {!hideHeader && <GNBHeader />}
      {children}
      {!hideFooter && <GNBFooter />}
    </>
  );
}
